import React from "react";
import { Flex, Stack, Box, HStack } from "@chakra-ui/react";
import Logo from "./../../../assets/img/LOGO.png";
import Links from "./links";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

function Content({ routes, onLinkClick, activePath }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleLogoutClick = () => {
    localStorage.clear();
    navigate("/login");

  };
  return (
    <Flex dir="rtl" direction="column" height="100%" pt="25px">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img src={Logo} alt="Company Logo" className="logo" />
        <div className="sperator"></div>
      </div>
      <Stack direction="column" height="100%" >
        <Box ps="5px">
          <Links
            routes={routes}
            onLinkClick={onLinkClick}
            activePath={activePath}
          />
        </Box>

        <Stack  >

          <React.Fragment>
            <HStack
              className={`sidebar-Icon`}
              cursor="pointer"
              spacing="30px"
              mt={"25px"}
              mr={"10px"}
              onClick={() => handleLogoutClick()}
            >
              <FontAwesomeIcon icon={faRightFromBracket} color="red" />
              <div
                style={{
                  fontWeight: "bold",
                  cursor: "pointer ",
                  color: "red",

                }}
              >
                {t("Logout")}
              </div>
            </HStack>
          </React.Fragment>
        </Stack>
      </Stack>
    </Flex>
  );
}

export default Content;
